import { FC } from 'react';
// Types
import { DroppableIds, ContentType } from 'app/types/ContentItem';
// Mui
import { Box } from '@mui/material';
// Components
import DataLoading from 'app/components/DataLoading';
// 
import ContentDroppable from './ContentDroppable';
import ContentDraggable from './ContentDraggable';
import ContentItem from './ContentItem';
import TemplatesFilter from './TemplatesFilter';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  templateIds: number[];
}

const TemplatesTabContent:FC<Props> = ({
  // Props
  templateIds
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <TemplatesFilter />
      <ContentDroppable droppableId={DroppableIds.Template}>
        <DataLoading data={templateIds} text={t('dialogs.reportPreset.noTemplatesData')}>
          {(data) => (
            <Box sx={{ display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
              {data.map((id, index) => (
                <ContentDraggable
                  key={`${ContentType.Template} item ${id}`}
                  index={index}
                  draggableId={`${ContentType.Template}-${id}`}
                ><ContentItem id={id} contentType={ContentType.Template} /></ContentDraggable>
              ))}
            </Box>
          )}
        </DataLoading>
      </ContentDroppable>
    </Box>
  )
}

export default TemplatesTabContent